// CoachCallout — T-011. Speaks to a different audience, so it should feel
// visibly separate from the rest of the page. --color-steel replaces lime as
// the accent.

import type { JSX } from "react";
import { Link } from "react-router-dom";
import { useI18n } from "../../i18n";

export function CoachCallout(): JSX.Element {
  const { t } = useI18n();
  return (
    <section
      id="coach"
      aria-label="coach-callout"
      className="border-b border-[var(--color-line)] bg-[var(--color-slab)]"
    >
      <div className="mx-auto grid w-full max-w-[1280px] grid-cols-1 items-center gap-0 px-0 sm:px-10 lg:grid-cols-[1fr_1.2fr]">
        <div className="relative aspect-[4/3] w-full overflow-hidden bg-[var(--color-void)] lg:aspect-auto lg:h-full lg:min-h-[420px]">
          <img
            src="/img/coach-portrait.webp"
            alt={t("landing.coachCallout.alt")}
            width={1376}
            height={768}
            loading="lazy"
            className="absolute inset-0 h-full w-full object-cover"
          />
        </div>
        <div className="p-8 lg:p-12">
          <p
            className="font-subhead text-sm uppercase tracking-[0.06em]"
            style={{ color: "var(--color-steel)" }}
          >
            {t("landing.coachCallout.eyebrow")}
          </p>
          <h2 className="font-display mt-2 text-4xl uppercase leading-[1.05] tracking-[0.02em] text-[var(--color-ink-hi)] sm:text-5xl">
            {t("landing.coachCallout.title")}
          </h2>
          <p
            className="mt-4 max-w-prose font-sans text-base text-[var(--color-ink)] sm:text-lg"
            style={{ lineHeight: 1.5 }}
          >
            {t("landing.coachCallout.body")}
          </p>
          <Link
            to="/app/coach"
            className="mt-8 inline-flex items-center justify-center px-6 py-3 font-subhead text-base uppercase tracking-[0.06em] transition-colors duration-[120ms] ease-[cubic-bezier(0.2,0,0,1)]"
            style={{
              minHeight: "44px",
              borderRadius: "var(--radius-sharp)",
              backgroundColor: "var(--color-steel)",
              color: "var(--color-void)",
            }}
          >
            {t("landing.coachCallout.cta")}
          </Link>
        </div>
      </div>
    </section>
  );
}
